export type TournamentPaymentRefundStatus =
  | "eligible"
  | "refunded"
  | "partially_refunded";

export type TournamentPaymentFlow = "linked" | "orphan";

export type TournamentPaymentSource = "registration" | "admin";

export interface TournamentStripePayment {
  paymentId: string;
  customerId: string;
  playerId: string | null;
  playerName: string;
  playerLicenceId: string | null;
  email: string | null;
  amountCents: number;
  amountEuros: number;
  boardCount: number;
  paidAt: string | null;
  refundStatus: TournamentPaymentRefundStatus;
  selectable: boolean;
  flow: TournamentPaymentFlow;
  paymentSource?: TournamentPaymentSource;
}

export interface OrphanScanPeriod {
  start: string;
  end: string;
  source: "labels" | "boards" | "participations";
}

export interface TournamentPaymentsListResult {
  linked: TournamentStripePayment[];
  orphan: TournamentStripePayment[];
  orphanScanPeriod: OrphanScanPeriod | null;
}

export type RefundItemStatus =
  | "succeeded"
  | "failed"
  | "already_refunded";

export interface RefundResultItem {
  paymentId: string;
  playerId?: string | null;
  email?: string | null;
  amountCents?: number;
  status: RefundItemStatus;
  stripeRefundId?: string | null;
  error?: string;
}

export interface RefundTournamentPaymentsResult {
  batchId: string;
  status: "completed" | "failed" | "partial_failure";
  refunds: RefundResultItem[];
  succeededCount: number;
  failedCount: number;
}

export const REFUND_CONFIRMATION_TOKEN = "REMBOURSER";
